// extracted by mini-css-extract-plugin
export default {"photo_page":"PhotoPage_photo_page__2A5hl"};